<template>
    <div v-if='appointment'>
        
        <b-modal centered ref="appointmentDialog" title="Edit appointment" size="md">
            <div class='d-block'>
                <!-- <div class='alert-warning' v-if='item.staff_id && item.site_id && !selectedClinicianHasSessionAvailabilityForSite'>WARNING!</div> -->
                <div class="form-row">
                    <inline-error v-bind:errors='errors' type='staff_id'></inline-error>
                    <label class="col-form-label col-6">Clinician</label>
                    <select class="form-control col-18" v-model='item.staff_id'>
                        <option v-for="user in users" :key='user.id' :value='user.id' v-text='formatNameCompliant(user)'></option>
                    </select>
                </div>
                <div class="form-row">
                    <inline-error v-bind:errors='errors' type='user_id'></inline-error>
                    <label class="col-form-label col-6">Patient</label>
                    
                    <input v-show='appointment.id' type='text' readonly class="form-control-plaintext col-18" :value='formatName(appointment.user)'>
                    <autocomplete v-show='!appointment.id' ref='userauto' class="form-control col-18"
                        source="/api/v1/patients?search="
                        results-property="data"
                        results-value="id"
                        @selected='(obj) => {item.user_id = obj.value; user = obj.selectedObject}'
                        @clear='item.user_id = null; user = null; $refs.threadauto.clear()'
                        :results-display="formattedUserDisplay"
                        :request-headers="authHeaders"
                        >
                    </autocomplete>
                    <patient-banner class='m-1 p-1' style='background-color: white; border: solid black 1px' v-if='user' v-bind:user.sync='user' />
                </div>
                <div class="form-row">
                    <inline-error v-bind:errors='errors' type='thread_id'></inline-error>
                    <label class="col-form-label col-6">Request</label>
                    
                    <input v-show='appointment.id'  type='text' readonly class="form-control-plaintext col-18" :value='formattedRequestDisplay(appointment.thread)'>
                    <input v-show='!appointment.id & !item.user_id' type='text' readonly class="form-control-plaintext col-18" value='Please select a patient first'>
                    <autocomplete ref='threadauto' v-show='!appointment.id && item.user_id' class="form-control col-18"
                        :source='"/api/v1/threads/searchByUser/" + item.user_id + "?search="'
                        results-property="data"
                        results-value="id"
                        @selected='(obj) => {item.thread_id = obj.value}'
                        @clear='item.thread_id = null'
                        :results-display="formattedRequestDisplay"
                        :request-headers="authHeaders"
                        >
                    </autocomplete>
                </div>
                
                <hr>
                <div class="form-row">
                    <inline-error v-bind:errors='errors' type='appointment_type_id'></inline-error>
                    <label class="col-6">Mode</label>
                    <b-form-group class="col-18">
                        <b-form-radio-group
                        v-model.number="item.appointment_type_id"
                        value-field='id'
                        text-field='name'
                        :options="appointment_types"
                        plain
                        stacked
                        name="appointment_type"
                        >
                        </b-form-radio-group>
                    </b-form-group>
                </div>
                <hr>
                <!-- if mode is == face to face && more than one site > show site -->
                <div v-if='$root.provider && $root.provider.site && $root.provider.site.length > 1 && (item.appointment_type_id == "1")'>
                    <div class="form-row">
                        <inline-error v-bind:errors='errors' type='site_id'></inline-error>
                        <label class="col-6">Site</label>
                        <b-form-group class="col-18">
                        <b-form-radio-group
                            stacked
                            plain
                            v-model="item.site_id"
                            name="site_id">
                            <b-form-radio class="" :disabled='!selectedClinicianHasSessionAvailability(site.id)' :value='site.id' :key='site.id' v-for='(site) in $root.provider.site'><span>{{site.name + (user && user.provider && site.id == user.provider.site_id ? " (preferred)" : "")}}</span></b-form-radio>
                        </b-form-radio-group>
                        </b-form-group>
                        <inline-error type='site_id'></inline-error>
                    </div>
                    <hr>
                </div>

                <!-- <div class="form-row">
                    <label class="col-6">Create as</label>
                    <b-form-group class="col-18">
                        <b-form-radio-group
                        v-model="create_type"
                        value-field='id'
                        text-field='name'
                        :options="[{id: 1, name: 'Invitation for patient to create appointment'}, {id: 2, name: 'Full appointment'}]"
                        plain
                        stacked
                        name="create_as"
                        ></b-form-radio-group>
                    </b-form-group>
                </div> -->

                <template>
                    <div class="form-row">
                        <inline-error v-bind:errors='errors' type='start_at'></inline-error>
                        <label class="col-6 col-form-label">Start At</label>
                        <!-- <select class="form-control col-18" v-model='item.start_at'>
                            <option v-for="(appointment) in session" 
                                :value='appointment.start_at' 
                                :key='appointment.start_at' 
                                >{{moment(appointment.start_at).format('HH:mm')}}</option>
                        </select> -->
                        <div class="col-18">
                            <div class='d-flex flex-row'>
                                <datetime2 v-model="item.start_at"></datetime2>
                            </div>
                            <small id="emailHelp" class="form-text text-muted">Leave "Start At" blank to send an invitation to the patient so that they can select their own appointment date.</small>
                        </div>
                    </div>
                    
                    
                    <!-- <div class="form-row">
                        <inline-error v-bind:errors='errors' type='length'></inline-error>
                        <label class="col-6 col-form-label">End At</label>
                        <datetime2 v-model="item.end_at"></datetime2>
                    </div> -->
                </template>
                <!-- <template v-else> -->
                    <div class="form-row">
                        <inline-error v-bind:errors='errors' type='length'></inline-error>
                        <label class="col-6 col-form-label">{{ $t("translations.duration_in_minutes") }}</label>
                        <input type='number' 
                            min="0" max="720" size='8' step='1' 
                            class="form-control col-18" v-model='item.length' >
                        <!-- <select class="form-control col-18" v-model='item.length'>
                            <option disabled value="">{{$t('translations.please_select')}}</option>
                            <option v-for='length in appointment_lengths' :key='length' :value='length'>{{length}} minutes</option>
                        </select> -->
                    </div>
                <!-- </template> -->

                <hr>

                <!-- if session.length > 1 -->
                <div class="form-row"  v-if='item.start_at'>
                    <inline-error v-bind:errors='errors' type='appointment_session_type_id'></inline-error>
                    <label class="col-6 col-form-label">Session Type</label>
                    <select class="form-control col-18" v-model='item.appointment_session_type_id'>
                        <option disabled v-if='!item.staff_id'>Please select a clinician first</option>
                        <option v-else :key='session_type.id' :value='session_type.id' v-for='session_type in $root.lookup.staff.find(obj => {return this.item.staff_id == obj.id}).appointment_session_type'>{{session_type.name}}</option>
                    </select>
                </div>
                <div class="form-row"  v-else>
                    <inline-error v-bind:errors='errors' type='appointment_session_type_ids'></inline-error>
                    <label class="col-6 col-form-label">Session Type</label>
                    <select multiple :select-size="4" class="form-control col-18" v-model='item.appointment_session_type_ids'>
                        <option disabled v-if='!item.staff_id'>Please select a clinician first</option>
                        <option v-else :key='session_type.id' :value='session_type.id' v-for='session_type in $root.lookup.staff.find(obj => {return this.item.staff_id == obj.id}).appointment_session_type'>{{session_type.name}}</option>
                    </select>
                </div>

            </div>

            <div slot="modal-footer" class="w-100 d-flex justify-content-between">
				<b-btn size="sm" variant="primary" v-on:click='$refs.appointmentDialog.hide()'>
					Cancel
				</b-btn>
                <b-btn v-if='item.id' size="sm" variant="warning" v-on:click='deleteAppointment()'>
					Delete
				</b-btn>
                <b-btn v-if='item.id' size="sm" class="" variant="primary" v-on:click='updateAppointment()'>
                    Update
                </b-btn>
                <b-btn v-else size="sm" class="" variant="primary" v-on:click='createAppointment()'>
                    Create
                </b-btn>
			</div>
		</b-modal>
    </div>
</template>

    <script>
    	export default {
    		props: {
                thread_id: null,
                appointment : null,
                session: null,
            },
    		data: function(){
    			return {
                    errors: [],
                    users: this.$root.lookup.staff,
                    item: {
                        appointment_session_type_id: null,
                        staff_id: null,
                        site_id: '',
                        appointment_session_type_ids: [],
                        appointment_type_id: "1",
                        thread_id: null,
                        user_id: null,
                    },
                    user: {provider: {site_id: null}, forenames: null, surname: null, dob: null, nhs_number: null},
                    sites: this.$root.provider.site,
                    appointment_types: [],
                    selected: '',
                    appointment_lengths: [5,10,15,20,25,30,35,40,45,50,55,60],
                    create_type: 1,
    			};
    		},
            mounted() {
                Object.keys(this.$root.lookup.appointment_types).forEach(key => {
                    this.appointment_types.push({
                        id: key, 
                        name: this.$t("translations." + this.$root.lookup.appointment_types[key])
                    })
                });
            },
    		computed: {
                authHeaders () {
                    return {
                        'Authorization': axios.defaults.headers.common['Authorization'],
                        'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
                    }
                },
                selectedClinicianHasSessionAvailabilityForSite() {
                    return this.hasSessionAvailabilityForSite(
                        this.users.find(obj => {return obj.id == this.item.staff_id}).availability_date, 
                        this.users.find(obj => {return obj.id == this.item.staff_id}).appointment_session_type, 
                        this.item.site_id);
                }
                

    		},
    		watch: {
                "item.appointment_type_id": function() {
                    if(this.item.appointment_type_id !== 1) {
                        this.item.site_id = null;
                    }
                },
                "item.site_id": function() {
                    if(!this.$root.provider.site.find(obj => {return obj.id == this.item.site_id})) {
                        this.item.site_id = null;
                    }
                }
            },

    		methods: {
                selectedClinicianHasSessionAvailability(site_id) {
                    if(this.users && this.item.staff_id) {
                        return this.hasSessionAvailabilityForSite(
                            this.users.find(obj => {return obj.id == this.item.staff_id}).availability_date, 
                            this.users.find(obj => {return obj.id == this.item.staff_id}).appointment_session_type, 
                            site_id);
                    }
                    return false;
                },
                formattedUserDisplay (result) {
                    // var bannerComponent = Vue.component("patient-banner");
                    // var banner = new bannerComponent({propsData: { user: result }});
                    // //var banner = new this.$options.components["patient-banner"]({propsData: { user: result }});
                    // //console.info(banner);
                    // banner.$root.lookup = this.$root.lookup;
                    // console.info(banner);
                    // banner.$mount();
                    if(result) {
                        //return banner;
                        //return "<patient-banner :show-close='true' v-on:close='closePanel()' v-bind:user.sync='result' />"
                        //return "<span style='background-color: red'>" + this.formatNameCompliant(result) + "</span>";
                        return this.formatNameCompliant(result) 
                            + (result.dob ? " | " + this.formatDate(result.dob) : "")
                            + (result.gender ? " | " + this.getGender(result.gender) : "")
                            + (result.nhs_number ? " | " + result.nhs_number.replace(/(.{3})/,"$1 ").replace(/(.{7})/,"$1 ") : "");
                    }
                    return '';
                },
                formattedRequestDisplay (result) {
                    if(result) {
                        return "[" + result.id + "] " + result.subject;
                    }
                    return '';
                },
                show() {
                    this.$refs.appointmentDialog.show();
                    Vue.nextTick(() => {
                        this.errors = [];
                        //if(this.appointment.id) {    
                        this.item.id = this.appointment.id;
                        if(this.appointment.appointment_session_type) {
                            this.item.staff_id = this.appointment.appointment_session_type.user_id;
                        }
                        else {
                            this.item.staff_id = this.appointment.app_app_session_type_xref[0].appointment_session_type.user_id;
                        }
                        if(this.appointment.thread_id) {
                            this.item.thread_id = this.appointment.thread_id;
                        }
                        else {
                            this.item.thread_id = null;
                            this.$refs.threadauto.clear();
                            // this.$refs.threadauto.value = this.item.thread_id;
                            // this.$refs.threadauto.display = null;
                            // this.$refs.threadauto.selectedDisplay = null;
                        }

                        if(this.$refs.threadauto) {
                            this.$refs.threadauto.value = this.item.thread_id;
                        }
                        
                        this.item.site_id = this.appointment.site_id;
                        this.item.length = this.appointment.length;
                        this.item.start_at = this.appointment.start_at;
                        this.item.end_at = this.appointment.end_at;
                        this.item.appointment_type_id = this.appointment.appointment_type_id ? this.appointment.appointment_type_id : 1;
                        if(this.appointment.user_id) {
                            this.item.user_id = this.appointment.user_id;
                            //this.mergeUpdateItem(this.user, this.appointment.user, []);
                            this.user = this.appointment.user;
                        }
                        else {
                            this.item.user_id = null;
                            this.$refs.userauto.clear();
                            // this.$refs.userauto.value = this.item.user_id;
                            // this.$refs.userauto.display = null;
                            // this.$refs.userauto.selectedDisplay = null;
                        }

                        


                        //this.item.appointment_session_id = this.appointment.appointment_session_id;
                        if(this.appointment.start_at) {
                            this.item.appointment_session_type_id = this.appointment.appointment_session_type.id;
                        }
                        else {
                            this.item.appointment_session_type_ids = this.appointment.app_app_session_type_xref.map((elem) => {
                                return elem.appointment_session_type.id;
                            });
                        }
                    });
                        
                    
                },
                createAppointment(invite) {
                    this.errors = [];
                    this.setLoading(true);
                    var endpoint = this.$root.apiBase + '/appointments';
                    if(!this.item.start_at) {
                        endpoint += "/invite";
                    }
                    return axios.put(endpoint, this.item).then((res) => {
                        this.$refs.appointmentDialog.hide();
                        this.setLoading(false);
                        this.$emit("appointmentUpdated", this.item);
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "update");
                    });
                },
                updateAppointment(invite) {
                    this.errors = [];
                    this.setLoading(true);
                    
                    return axios.post(this.$root.apiBase + '/appointments/' + this.item.id, this.item).then((res) => {
                        this.$refs.appointmentDialog.hide();
                        this.setLoading(false);
                        this.$emit("appointmentUpdated", this.item);
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "update");
                    });
                            
                },
                deleteAppointment(invite) {
                    this.errors = [];
                    this.setLoading(true);
                    this.item.thread_id = this.thread_id;
                    return axios.delete(this.$root.apiBase + '/appointments/' + this.item.id).then((res) => {
                        this.$refs.appointmentDialog.hide();
                        this.setLoading(false);
                        this.$emit("appointmentDeleted", this.item);
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "delete");
                    });
                            
                },
                
            }
    	}

    </script>
